import React from 'react';

// DJB-92/DJB-93: shared on/off property checkmarks for the Browse page.
// The filter model is a plain array of active flag keys: empty means the
// default "All songs" (no property filtering); ticking any property adds its
// key (which visually un-ticks "All songs") and multiple properties combine
// with AND. Used by the left filter area and the Artist editor column.
export const PROPERTY_FLAGS = [
  { key: 'neverIdle', label: 'Never Idle' },
  { key: 'ondemand', label: 'On Demand' },
  { key: 'neverNew', label: 'Never New' },
  { key: 'mix', label: 'Mix' },
  { key: 'freeSkipQueue', label: 'VIP' },
];

// DJB-173: "Deleted" rides along in the same active-keys array. Browse hides
// deleted tracks by default; ticking Deleted flips both columns to showing
// only deleted tracks (track.deleted is a plain boolean, so the AND-matching
// below covers it too).
export const DELETED_KEY = 'deleted';

export const trackMatchesProperties = (track, activeKeys) =>
  activeKeys.every((key) => Boolean(track[key]));

const PropertyChecks = ({ active, onChange }) => {
  const allSongs = active.length === 0;

  const toggleFlag = (key) => {
    onChange(
      active.includes(key)
        ? active.filter((k) => k !== key)
        : [...active, key]
    );
  };

  return (
    <div className="browse-props" role="group" aria-label="Property filters">
      <label className={`browse-prop ${allSongs ? 'is-on' : ''}`}>
        <input
          type="checkbox"
          checked={allSongs}
          // "All songs" is the resting state: ticking it clears every
          // property; un-ticking it directly would mean "no songs", so
          // that is a no-op
          onChange={() => onChange([])}
        />
        <span className="browse-prop-box" aria-hidden="true" />
        All songs
      </label>
      {PROPERTY_FLAGS.map(({ key, label }) => (
        <label
          key={key}
          className={`browse-prop ${active.includes(key) ? 'is-on' : ''}`}
        >
          <input
            type="checkbox"
            checked={active.includes(key)}
            onChange={() => toggleFlag(key)}
          />
          <span className="browse-prop-box" aria-hidden="true" />
          {label}
        </label>
      ))}
      <label
        className={`browse-prop browse-prop--deleted ${
          active.includes(DELETED_KEY) ? 'is-on' : ''
        }`}
      >
        <input
          type="checkbox"
          checked={active.includes(DELETED_KEY)}
          onChange={() => toggleFlag(DELETED_KEY)}
        />
        <span className="browse-prop-box" aria-hidden="true" />
        Deleted
      </label>
    </div>
  );
};

export default PropertyChecks;
